import {deserialize, serialize, inheritSerialization} from "cerialize";

import BaseEntity from "./BaseEntity";
import TableColumn from "./TableColumn";
import AppConfig from "../AppConfig";

@inheritSerialization(BaseEntity)
export default class CashierCategory extends BaseEntity {

    @serialize
    @deserialize
    public merchant_kode: string = "";

    @serialize
    @deserialize
    public code: string = "";

    @serialize
    @deserialize
    public name: string = "";

    @serialize
    @deserialize
    public is_active: boolean = true;

    @serialize
    @deserialize
    public created_at: string = "";

    @serialize
    @deserialize
    public updated_at: string = "";

    public codeFeedback() {
        return this.defaultPropertyFeedback('code');
    }

    public nameFeedback() {
        return this.defaultPropertyFeedback('name');
    }

    public hasValid() {
        return this.codeFeedback().valid && this.nameFeedback().valid;
    }

    public table() {
        const {
            code, name, is_active
        } = this;
        return {
            code, name, is_active
        };
    }

    public static columnName(): Array<TableColumn> {
        const table = new CashierCategory().table();
        let keys = Object.keys(table);

        return keys.map((field: any) => {
            const tableColumn = new TableColumn();
            tableColumn.name = AppConfig.getVm().$t(`label.${field}`);

            return tableColumn;
        });
    }
}

